// app store
export const initialAppState = {
  steps: [
    {
      type: '',
      source: '',
      id: '',
    },
  ],
  customData: {
    bottle: {}, // 選択されたボトル（カラー&サイズ）
    bottleColorData: {}, // 選択されたカラーのデータ
    parts: [], // ボトル以外のパーツ類
  },
};

// ui store
export const initialUiState = {
  isErrorAddToCart: false, // カートのエラー状態
  errorMesageAddToCart: '', // カートのエラーメッセージ
};

let isMTA = false;
if(window.CB && window.CB.isMTA) {
  isMTA = true;
}

export const getCustomData = (stepState, dataState) => {
  // ボトルカラーの ID を取得
  let colorId = null;
  if (isMTA) {
    colorId = stepState[0]['bottleColor']
  } else {
    colorId = stepState.filter((item) => item.type === 'bottleColor')[0].id;
  }
  // ボトルサイズの ID を取得
  const sizeId = stepState.filter((item) => item.type === 'bottleSize')[0].id;

  // ボトル以外のパーツを配列化
  const parts = stepState.filter(
    (item) => item.type !== 'bottleColor' && item.type !== 'bottleSize' && item.source !=='Boot'
  );
  const boots = stepState.filter(
    (item) => item.source === 'Boot'
  )
  // パーツデータを配列化
  const partsList = parts.map(
    (item) => dataState[item.source].products[item.id]
  );
  
  let bootsList = null;
  if (isMTA) {
    bootsList = boots.map(
      (item) => dataState[item.source].products[item.id]
    )
  }

  // ボトルカラーのデータ
  const bottleColorData = dataState['Bottle'].products[colorId];
  // ボトルにサイズバリエーションがある場合
  // ない場合はひとまず無視
  const bottle = bottleColorData.variants[sizeId];

  return {
    bottle: bottle,
    bottleColorData: bottleColorData,
    partsList: partsList,
    bootsList: bootsList
  };
};
